export function replaceTextRecurse(description = '',{ split, join }){
    let text = description;
    if ((typeof text) === 'string')
        return text
            .split(split)
            .map(item => item.split(join).join(split))
            .join(join);
    return text;
}